import { computed, get } from '@ember/object';

export default function includes(arrayKey, value) {
  return computed(`${arrayKey}.[]`, function () {
    return get(this, arrayKey).includes(value);
  });
}
